import {getInjection} from '@runlab/di'
import {Routes} from '@/src/config/routes'
import {getClient} from '@/src/shared/utils/api-factory'
import {LAYOUT_REVALIDATE_SECONDS} from '@/src/config/settings'
import {toClientSession} from '@/src/core/domain/session/client-session'

export const fetchPageLayoutFn = async (onResponse?: (response: Response) => Promise<void>) => {
  return getInjection('IInstrumentationService').startSpan(
    {
      name: `Запрос на данные шаблона сайта [${(typeof window === 'undefined' && 'SERVER') || 'BROWSER'}]`,
    },
    async () => {
      const sessionService = getInjection('SessionServiceInterface')

      const [session, webApiHeaders] = await sessionService.load()

      const client = getClient()

      let layoutData: LayoutData

      if (typeof window === 'undefined') {
        const {cachedFetch} = await import('@/src/shared/utils/server-cache')
        layoutData = await cachedFetch(
          ['layout', Routes.webApi.layout.data],
          LAYOUT_REVALIDATE_SECONDS,
          () => client.get<LayoutData>(Routes.webApi.layout.data, {withoutSession: true}).then(data => {
            const header = {...data.header}
            delete header.cart
            return {...data, header, session: null}
          }),
        )
      } else {
        layoutData = await client.get<LayoutData>(Routes.webApi.layout.data, {
          headers: webApiHeaders,
          onResponse: onResponse,
        })
      }

      const freshSession = typeof window === 'undefined' ? session : (await sessionService.load())[0]
      return {...layoutData, session: toClientSession(freshSession)}
    },
  )
}
